<nz-layout>
  <nz-content>
    <app-reusable-table
      title="Active Episodes of Care"
      [isLoading]="isLoading"
      [columns]="[
        '',
        'Potential Diagnosis',
        'Activation Date',
        'End Date',
        'Status',
      ]"
      [rowFields]="[
        'isHospitalized',
        'potentialDiagnosis',
        'activationDate',
        'endDate',
        'status',
      ]"
      [data]="episodesOfCare"
      [expandComponent]="expandComp"
    />
  </nz-content>
</nz-layout>
